import IdentityProviderManagementComponent from 'components/desktop/StandingData/IdentityProvider/Management/IdentityProviderManagementComponent';

const IdentityProviderManagementContainer = () => {
	return (
		<main className="container">
			<IdentityProviderManagementComponent />
		</main>
	);
};

export default IdentityProviderManagementContainer;
